enum FileBrowserItemType {
  Drive = 'DRIVE_ITEM',
  Sharing = 'SHARING_ITEM',
}

export default FileBrowserItemType;
